import { z } from 'zod';

/** @aiInvariant append-only; mirrors Prisma `LogisticsCalculationStatus`. */
export enum LogisticsCalculationStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
}
export const LogisticsCalculationStatusSchema = z.nativeEnum(LogisticsCalculationStatus);

/** @aiInvariant append-only; mirrors Prisma `LogisticsCalculationPublicViewKind`. */
export enum LogisticsCalculationPublicViewKind {
  HTML_VIEW = 'HTML_VIEW',
  PDF_DOWNLOAD = 'PDF_DOWNLOAD',
}
export const LogisticsCalculationPublicViewKindSchema = z.nativeEnum(
  LogisticsCalculationPublicViewKind,
);

export const LOGISTICS_CALCULATION_PUBLIC_CODE_REGEX = /^RL-\d{5}$/;
export const LOGISTICS_CALCULATION_STYLES = ['form', 'branded'] as const;
export const LogisticsCalculationStyleSchema = z.enum(LOGISTICS_CALCULATION_STYLES);
export type LogisticsCalculationStyle = z.infer<typeof LogisticsCalculationStyleSchema>;

export const LOGISTICS_CALCULATION_PAYMENT_LABELS = [
  'novat',
  'vat_included',
  'individual',
] as const;
export const LogisticsCalculationPaymentLabelSchema = z.enum(LOGISTICS_CALCULATION_PAYMENT_LABELS);
export type LogisticsCalculationPaymentLabel = z.infer<
  typeof LogisticsCalculationPaymentLabelSchema
>;
